import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ResumeService} from '../../../../services/resume.service';
import {DxDataGridComponent} from 'devextreme-angular';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from '../../../../services/common.service';

// import { Workbook } from 'exceljs';
// import { exportDataGrid } from 'devextreme/excel_exporter';
// import { saveAs } from 'file-saver-es';

@Component({
  selector: 'app-resume-report-details',
  templateUrl: './resume-report-details.component.html',
  styleUrls: ['./resume-report-details.component.scss']
})
export class ResumeReportDetailsComponent implements OnInit {
  private static tableState: any;
  uniqueId: string;
  id: number;
  columns: any[] = [];
  data: [];
  @ViewChild('table', {static: false}) dataGrid!: DxDataGridComponent;
  currentFilter: any;
  showFilterRow: boolean;
  showHeaderFilter: boolean;
  applyFilterTypes: any;
  columnsLoaded: boolean;
  title: string;
  windowWidth: number;
  model = 'resume-details';
  isLoading: boolean;
  viewName: string;
  isViewSaving: boolean;
  isViewSubmitting: boolean;
  views: any;
  searchEditorOptions: any;
  internalHeight: number;

  constructor(public route: ActivatedRoute,
              public router: Router,
              public dialog: MatDialog,
              private commonService: CommonService,
              private resumeService: ResumeService,
              public toastService: ToastMessagesService) {
    this.title = '';
    this.showFilterRow = true;
    this.showHeaderFilter = true;
    this.applyFilterTypes = [{
      key: 'auto',
      name: 'Immediately',
    }, {
      key: 'onClick',
      name: 'On Button Click',
    }];

    this.currentFilter = this.applyFilterTypes[0].key;
    this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
    this.windowWidth = window.innerWidth - 150;
    this.columnsLoaded = false;
    this.viewName = '';
    this.isViewSaving = false;
    this.isViewSubmitting = false;
    this.views = {
      isDisplaying: false,
      isLoading: true,
      isDeleting: false,
      isUpdating: false,
      records: []
    };

    this.searchEditorOptions = {
      format: 'dd-MM-yyyy' // Specify the desired date format for search field
    };

    this.internalHeight = window.innerHeight - 272;
  }


  private static getOrderDay(rowData: { OrderDate: string | number | Date; }) {
    return (new Date(rowData.OrderDate)).getDay();
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.initializeParams();
      await this.initializeColumns();
      await this.fetchData();
      this.columnsLoaded = true;

      //#region Load manually the table Views and apply default
      const request = await this.resumeService.fetchUserTableViews(this.model);
      request.object.map(r => r.state = JSON.parse(r.state));
      this.views.records = request.object;
      const defaultView = this.views.records.find(record => record.isDefault);
      if (defaultView) {
        setTimeout(() => {
          console.log(defaultView);
          this.applyView(defaultView);
        }, 2000);
        this.toastService.toastMessages('Εφαρμόζουμε την προεπιλεγμένη εμφάνιση που έχετε επιλέξει');
      }
      //#endregion
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    }
  }

  //#region Views
  initViewStoring() {
    this.isViewSaving = true;
  }

  hideViews() {
    this.views.isDisplaying = false;
  }

  async loadViews() {
    this.views.isDisplaying = true;
    this.views.isLoading = true;

    try {
      const request = await this.resumeService.fetchUserTableViews(this.model);
      request.object.map(r => r.state = JSON.parse(r.state));
      this.views.records = request.object;
    } catch (e) {
      this.toastService.toastErrorMessage('Δεν μπορέσαμε να φορτώσουμε τις απεικονίσης σας');
    } finally {
      this.views.isLoading = false;
    }
  }

  async submitView() {
    try {
      this.isViewSubmitting = true;
      const view = {
        name: this.viewName,
        state: JSON.stringify(ResumeReportDetailsComponent.tableState),
        model: this.model,
        columns: JSON.stringify(this.columns)
      };
      await this.resumeService.storeUserTableView(view);
      this.toastService.toastMessages('Η απεικόνιση του πίνακα αποθηκεύτηκε με επιτυχία');
      if (this.views.isDisplaying) {
        await this.loadViews();
      }
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    } finally {
      this.isViewSubmitting = false;
    }
  }

  closeViewSaving() {
    this.viewName = '';
    this.isViewSaving = false;
  }

  deleteView(id: number): void {
    const confirm = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'Είστε σίγουροι ότι Θέλετε να διαγράψετε το πρότυπο εμφάνισης?',
        title: 'Διαγραφή προτύπου',
        icon: 'delete',
        iconColor: 'blue',
      }
    });

    confirm.afterClosed().subscribe(async response => {
      if (response) {
        try {
          this.views.isDeleting = true;
          await this.resumeService.deleteUserTableView(id);
          this.toastService.toastMessages('Το πρότυπο διαγράφηκε με επιτυχία');
          await this.loadViews();
        } catch (e) {
          this.toastService.toastErrorMessage(e.message);
        } finally {
          this.views.isDeleting = false;
        }
      }
    });
  }

  shouldBeDisabled() {
    return this.views.isLoading || this.views.isDeleting || this.views.isUpdating || this.isViewSubmitting;
  }

  applyView(view: any) {
    this.dataGrid.instance.state(view.state);
  }

  async setDefault(view: any, isDefault= false) {
    try {
      await this.resumeService.setDefaultUserTableView(this.model, isDefault ? view.id : -1);
      await this.loadViews();
    } catch (e) {
    this.toastService.toastErrorMessage(e.message);
    }
  }

  //#endregion

  //#region Table State Management
  saveState(state) {
    ResumeReportDetailsComponent.tableState = state;
  }

  loadState() {
  }

  //#endregion

  calculateFilterExpression(value: string, selectedFilterOperations: any, target: string) {
    const column = this as any;
    if (target === 'headerFilter' && value === 'weekends') {
      return [[ResumeReportDetailsComponent.getOrderDay, '=', 0], 'or', [ResumeReportDetailsComponent.getOrderDay, '=', 6]];
    }
    return column.defaultCalculateFilterExpression.apply(this, arguments);
  }

  orderHeaderFilter(data: { dataSource: { postProcess: (results: any) => any; }; }) {
    data.dataSource.postProcess = (results) => {
      results.push({
        text: 'Weekends',
        value: 'weekends',
      });
      return results;
    };
  }

  async initializeColumns() {
    try {
      const request = await this.resumeService.fetchResumeColumns(this.uniqueId);
      this.title = request.title;
      this.columns = request.columns;
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    }
  }

  async initializeParams(): Promise<void> {
    return new Promise((resolve => {
      this.route.queryParams.subscribe(async (params) => {
        this.uniqueId = params.uniqueId;
        this.id = +params.id;
        resolve();
      });
    }));
  }

  async fetchData(): Promise<void> {
    const request = await this.resumeService.fetCompletedFormResults(this.uniqueId);
    this.data = request.object;
  }

  async downloadPDF(data) {
    try {
      const params = {
        id: data.data.id,
        uniqueToken: data.data.uniqueToken
      };
      const response = await this.resumeService.downloadResume(params);
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = URL.createObjectURL(
        new Blob([this.commonService.base64ToBlob(response)], {
          type: 'application/pdf'
        })
      );
      link.click();
    } catch (e) {
      this.toastService.toastErrorMessage(e.message ? e.message : e.serverMessage);
    }
  }

  async navigateToResumeDetails(data) {
    const baseUrl = window.location.href.split('#')[0];
    const routeUrl = this.router.serializeUrl(this.router.createUrlTree(['/home/resume-form-i'], {
      queryParams: {
        id: data.data.id,
        mode: 'author',
        uniqueToken: data.data.uniqueToken
      }
    }));
    const url = baseUrl + '#' + routeUrl;
    window.open(url, '_blank');
  }

  onExporting(e: any) {
  }

  displayCaption(label) {
    if (!label) {
      return '';
    }
    if (label.length > 40) {
      label = label.slice(0, 40) + '...';
    }

    return label;
  }

  renderNonDateColumns(): any[] {
    return this.columns.filter(column => column.type !== 'date');
  }

  renderDateColumns(): any[] {
    return this.columns.filter(column => column.type === 'date');
  }
}
